import { CONFIG } from '../../config';

/**
 * 키보드 입력 처리
 */
export class KeyboardInput {
    private keys: Set<string>;
    private previousKeys: Set<string>;
    private keydownHandler: ((e: KeyboardEvent) => void) | null = null;
    private keyupHandler: ((e: KeyboardEvent) => void) | null = null;

    constructor() {
        this.keys = new Set();
        this.previousKeys = new Set();
        this.setup();
    }

    setup(): void {
        this.keydownHandler = (e: KeyboardEvent) => {
            this.keys.add(e.key);
        };
        this.keyupHandler = (e: KeyboardEvent) => {
            this.keys.delete(e.key);
        };

        window.addEventListener('keydown', this.keydownHandler);
        window.addEventListener('keyup', this.keyupHandler);
    }

    destroy(): void {
        if (this.keydownHandler) {
            window.removeEventListener('keydown', this.keydownHandler);
            this.keydownHandler = null;
        }
        if (this.keyupHandler) {
            window.removeEventListener('keyup', this.keyupHandler);
            this.keyupHandler = null;
        }
        this.keys.clear();
        this.previousKeys.clear();
    }

    update(): void {
        this.previousKeys = new Set(this.keys);
    }

    isKeyDown(...keys: string[]): boolean {
        return keys.some(key => this.keys.has(key));
    }

    isKeyJustPressed(...keys: string[]): boolean {
        return keys.some(key => this.keys.has(key) && !this.previousKeys.has(key));
    }

    getAxis(axisName: 'horizontal' | 'vertical'): number {
        let value = 0;

        if (axisName === 'horizontal') {
            if (this.isKeyDown(...CONFIG.INPUT.KEYBOARD.LEFT)) value -= 1;
            if (this.isKeyDown(...CONFIG.INPUT.KEYBOARD.RIGHT)) value += 1;
        } else if (axisName === 'vertical') {
            if (this.isKeyDown(...CONFIG.INPUT.KEYBOARD.UP)) value -= 1;
            if (this.isKeyDown(...CONFIG.INPUT.KEYBOARD.DOWN)) value += 1;
        }

        return value;
    }

    isConfirmPressed(): boolean {
        return this.isKeyJustPressed(...CONFIG.INPUT.KEYBOARD.CONFIRM);
    }

    isCancelPressed(): boolean {
        return this.isKeyJustPressed(...CONFIG.INPUT.KEYBOARD.CANCEL);
    }

    isUpPressed(): boolean {
        return this.isKeyJustPressed(...CONFIG.INPUT.KEYBOARD.UP);
    }

    isDownPressed(): boolean {
        return this.isKeyJustPressed(...CONFIG.INPUT.KEYBOARD.DOWN);
    }

    isLeftPressed(): boolean {
        return this.isKeyJustPressed(...CONFIG.INPUT.KEYBOARD.LEFT);
    }

    isRightPressed(): boolean {
        return this.isKeyJustPressed(...CONFIG.INPUT.KEYBOARD.RIGHT);
    }
}
